import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=39a8a1eb&scoped=true&"
import script from "./Category.vue?vue&type=script&lang=js&"
export * from "./Category.vue?vue&type=script&lang=js&"
import style0 from "./Category.vue?vue&type=style&index=0&id=39a8a1eb&scoped=true&lang=css&"
import style1 from "./Category.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a8a1eb",
  null
  
)

export default component.exports